import { createContext, useContext } from "react";
import _ from "lodash";

import { DevicesSets } from "../../../../../../helpers/devices.helpers";
import { TabItem } from "../../../../../../components/tabList";

interface TableContextValue {
  tabs: TabItem[];
  selectedTab: DevicesSets;
  onSelectedChange: (type: DevicesSets) => void;
}

export const TabsContext = createContext<TableContextValue>({
  tabs: [],
  selectedTab: DevicesSets.Discovered,
  onSelectedChange: _.noop,
});

export const useTabsContext = () => useContext(TabsContext);
